// @flow

import * as React from 'react';
import type { Node, } from 'react';
import { useFela, } from 'react-fela';

type TextPropTypes = {
  text: ?(string | [string, ]),
  mobileText: ?(string | Node | [string, ]),
  // displayStrict will cause mobileText to only display
  // on small breakpoint and text to only display on larger than small breakpoint
  // the default behaviour is to fall back to one of the texts if the other is missing
  displayStrict?: boolean,
  highlight: ?([[string, ], ] | string),
  kind: 'title' | 'kicker' | 'subTitle',
};

TeaserResponsiveText.defaultProps = {
  text: null,
  mobileText: null,
  displayStrict: false,
  highlight: null,
  kind: null,
};

const TEASER_TITLE_CLASSNAME = 'teaser-title';
const TEASER_SUB_TITLE_CLASSNAME = 'teaser-sub-title';
const TEASER_KICKER_CLASSNAME = 'teaser-kicker';

export default function TeaserResponsiveText({
  text,
  mobileText,
  displayStrict,
  highlight,
  kind,
}: TextPropTypes): React.Node {
  const { css, theme, } = useFela();
  const kindClassName = kind === 'kicker' ? TEASER_KICKER_CLASSNAME : kind === '' ? TEASER_SUB_TITLE_CLASSNAME : TEASER_TITLE_CLASSNAME;

  if (displayStrict || (mobileText && text && mobileText !== text)) {
    return (
      <>
        {mobileText ? (
          <span
            className={`${kindClassName} ${css({
              ...theme.mq({ from: 's', }, { display: 'none', }),
            })}`}
          >
            {highlightArray(mobileText, highlight)}
          </span>
        ) : null}
        {text ? (
          <span className={`${kindClassName} ${css({ ...theme.mq({ until: 's', }, { display: 'none', }), })}`}>{highlightArray(text, highlight)}</span>
        ) : null}
      </>
    );
  }

  const highlightText = highlightArray(mobileText, highlight) || highlightArray(text, highlight) || null;

  return <span className={kindClassName}>{highlightText}</span>;
}

type PartItemPropTypes = {
  part?: string,
  isStrong?: boolean,
};


PartItem.defaultProps = {
  part: null,
  isStrong: false,
};

function PartItem({ part, isStrong, }: PartItemPropTypes) {
  if (isStrong) {
    return <strong>{part}</strong>;
  }
  return part;
}

// 'stringArr' is an array of string, 'substringArrArr' is an array of array of strings
function highlightArray(stringArr, substringArrArr) {
  if (!Array.isArray(stringArr) || !Array.isArray(substringArrArr)) {
    // if input is not an array (could be a string or null), do not change anything
    return stringArr;
  }
  return stringArr.filter(item => item).map((item, index) => highlightString(item, substringArrArr[index], `sec-${index}`));
}

// 'string' is a string, 'substringArr' is an array of strings
function highlightString(string, substringArr, key) {
  if (!string) {
    return null;
  }
  if (!substringArr || substringArr.length === 0) {
    return <PartItem key={`${key}`} part={string} />;
  }
  const parts = string.split(new RegExp(`(${substringArr.join('|')})`, 'gi'));
  return parts.map((part, index) => (<PartItem key={`${key}-part-${index}`} part={part} isStrong={substringArr.map(item => item.toLowerCase()).includes(part.toLowerCase())} />));
}
